module.exports = __webpack_public_path__ + "img/img03.94d04719.png";